import { useEffect, useRef } from "react";
import { FullPageStatus } from "@/components/FullPageStatus";
import { useAuth } from "./AuthContext";

export function Login() {
  const { login } = useAuth();
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) {
      return;
    }

    hasRun.current = true;

    void login("/");
  }, [login]);

  return <FullPageStatus title="Signing in..." />;
}
